@use '@lib/assets/styles/main.scss' as *;

.formItems {
  @extend .row;
  & > [class*='Typography'] {
    padding-bottom: 24px;
  }
}

.formSubItems {
  @extend .row;
  margin-left: -4px;
  margin-right: -4px;
  & > div {
    padding-left: 4px;
    padding-right: 4px;
  }
}

.formItemFieldArray {
  & + .formItemFieldArray {
    margin-top: 16px;
  }
}

.formItemWithErrors {
  padding-bottom: 24px;
}

.formItemWithLeftLabel {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 16px;
}

.formItemWithRightLabel {
  display: grid;
  grid-template-columns: auto min-content;
  grid-gap: 16px;
  &.formItemWithLeftLabel {
    grid-template-columns: min-content auto min-content;
  }
}

.leftLabel {
  color: $gray700;
  white-space: nowrap;
  display: block;
  line-height: 56px;
}

.rightLabel {
  color: $gray700;
  white-space: nowrap;
  display: block;
  line-height: 56px;
}

.formItemColumn {
  @extend .col-xs-12;
}

.formItemGroup {
  margin-bottom: 8px;
}

.formItemError {
  color: $error900;
  padding: 4px 4px 0 16px;
}

.formIFieldArrayError {
  margin-top: -16px;
}

.formItemDescription {
  padding: 4px 0 0 16px !important;
  display: block;
}

.formItemMessage {
  margin-top: 16px;
  padding-bottom: 0;
}

.subFieldHead {
  padding-right: 56px;
  position: relative;
}

.subFieldDeleteBtn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  transition: opacity 0.3s ease;

  .formItemFieldArrayDragging & {
    opacity: 0;
  }
}

.subFieldAccordion {
  background-color: $blue20;
  border-radius: 6px;
  padding: 8px 56px 8px 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 56px;
  position: relative;
  cursor: pointer;
  border: none;
  text-align: left;
  width: 100%;
  .formItemFieldArrayDragging & {
    background-color: $blue50;
    box-shadow:
      0 2px 3px 1px rgba(#122977, 0.15),
      0 6px 10px 4px rgba(#122977, 0.05);
  }
}

.subFieldAccordionWithErrors {
  background-color: $error100;
}

.accordionClassNameDraggable {
  padding-left: 48px;
}

.subFieldPanel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 200ms ease;
}

.subFieldPanelOpen {
  grid-template-rows: 1fr;
}

.subFieldPanelInner {
  overflow: hidden;
}

.accordionContent {
  padding-top: 24px;
}

.errorsCount {
  background: $error900;
  color: $gray0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
}

.subFieldAccordionDragDrop {
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  padding: 8px;
  cursor: grab;
  svg {
    display: block;
  }
}

.subFieldAccordionIcon {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  transition: transform 200ms ease;

  .subFieldHeadOpened & {
    transform: translateY(-50%) rotate(180deg);
  }
}

.formItemEmptyState {
  margin-bottom: 24px;
}

.subFieldEmptyStateTitle {
  margin-bottom: 23px;
}

.subFieldEmptyStateText {
  margin-bottom: 48px;
}

.subFieldAddMoreBtn {
  padding-top: 32px;
  margin-bottom: 24px;
  display: flex;
}

.circleLoaderWrapper {
  z-index: 2;
}

.hidden {
  display: none !important;
}
